import { render, staticRenderFns } from "./CreateAdicionalLikelyModal.vue?vue&type=template&id=754303ae&scoped=true"
import script from "./CreateAdicionalLikelyModal.vue?vue&type=script&lang=js"
export * from "./CreateAdicionalLikelyModal.vue?vue&type=script&lang=js"
import style0 from "./CreateAdicionalLikelyModal.vue?vue&type=style&index=0&id=754303ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754303ae",
  null
  
)

export default component.exports